export default {
  install: function (Vue) {
    const f = [
      "gt-search-bar",
      "gt-oss-upload",
      "gt-search-grid-group",
      "gt-search-grid-item",
      "GtSvg",
      "GtTabs",
      "gt-dialog",
      "GtPageTitle",
      "GtTimeLine",
      "GtContentHeader",
      // "gt-node-picker",
      "gt-icon-legend",
      "gtFormItemTip",
      "gtContentBlock",
      "gtDropDown",
      "GtDataGrid",
      "GtTabAnchor",
      "GtDPicker",
      "GtCapsuleTag",
      "GtProductPicker",
      "gt-default-dialog",
      "gt-export-dialog",
      "GtFooterFixer",
      "GtRegionPicker",
      "GtIconTooltip",
      "GtMultipleUploader",
      "GtOrgTree",
      "GtEditor",
      "gt-searchbar-short",
      "GtMemberPicker",
      "wt-scan-date-picker",
      "GtSearchForm"
    ];
    f.forEach(item => {
      Vue.component(item, () => import(`./${item}/index.vue`));
    });
  }
};
